import CTA4 from './CTA4'
export default CTA4
